import { firstQueryValue } from '@/shared/lib';
import type { SortOrder } from '@/shared/lib';
import type { DraftMatrixSortField } from '../api/matrices.api';
import { parseCivilDateQuery } from './models-list-query';
import { parseBoundedIntegerQuery } from './rejected-list-query';

const DRAFT_SORT_FIELDS: readonly DraftMatrixSortField[] = ['updatedAt', 'title'];

export interface DraftsListSort {
  sort: DraftMatrixSortField | '';
  order: SortOrder | '';
}

export interface DraftsListFilters {
  updatedAt?: string;
  createdBy?: number;
}

const isDraftSortField = (value: unknown): value is DraftMatrixSortField =>
  DRAFT_SORT_FIELDS.includes(value as DraftMatrixSortField);

const isSortOrder = (value: unknown): value is SortOrder => value === 'asc' || value === 'desc';

export const toDraftsListSort = (sort: unknown, order: unknown): DraftsListSort =>
  isDraftSortField(sort) && isSortOrder(order) ? { sort, order } : { sort: '', order: '' };

export const parseDraftsListSort = (query: Record<string, unknown>): DraftsListSort =>
  toDraftsListSort(firstQueryValue(query.sort), firstQueryValue(query.order));

export const parseDraftsListFilters = (query: Record<string, unknown>): DraftsListFilters => ({
  updatedAt: parseCivilDateQuery(query.updatedAt),
  createdBy: parseBoundedIntegerQuery(query.createdBy),
});

export const countActiveDraftFilters = (filters: DraftsListFilters): number =>
  [filters.updatedAt, filters.createdBy].filter((value) => value !== undefined).length;

export const buildDraftsListUrlQuery = (
  { sort, order }: DraftsListSort,
  filters: DraftsListFilters
): Record<string, string | number> => ({
  ...(sort && order ? { sort, order } : {}),
  ...(filters.updatedAt ? { updatedAt: filters.updatedAt } : {}),
  ...(filters.createdBy ? { createdBy: filters.createdBy } : {}),
});
